import { FormSectionHandler } from '../entity.handler';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { TextField, EntityUtils, ComboField, MemoField, NumberField, DateTimeField } from '../utils';
import { ICONS } from '../icons';
import { NamedTaskResponse } from './model';

interface EditorValues {
    name: string;
    retries: number;
    delay: number;
    timeout: number;
    user: string;
    linked: string;
    state: string;
    results: string;
    data: string;
    created: string;
    updated: string;

}

export class TaskDetailsSectionHandler implements FormSectionHandler<NamedTaskResponse, EditorValues> {

    type = 'form';
    icon = ICONS.task;
    bulk = false;
    readonly = true;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string,
        public creating: boolean
    ) {
    }


    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.TASK.DETAILS.${key}`, values);
    }

    async applyUpdate(_entity: NamedTaskResponse, _payload: any): Promise<NamedTaskResponse> {
        throw new Error('Not implemented');
    }

    async mapEntityToEditor(entity: NamedTaskResponse): Promise<EditorValues> {
        return {
            name: entity.type,
            retries: entity.options.retries,
            delay: entity.options.delay,
            timeout: entity.options.timeout,
            user: entity.user && entity.user.name,
            linked: entity.linked && entity.linked.map(x => x.name).join('<br/>'),
            state: entity.state,
            results: JSON.stringify(entity.results),
            data: JSON.stringify(entity.data),
            created: entity.date.created,
            updated: entity.date.updated,
        };
    }

    async mapEditorToEntity(_entity: any, _values: EditorValues): Promise<any> {
        return {};
    }

    async getFields(entity: NamedTaskResponse): Promise<FormBuilderField[]> {



        const values = ['pending', 'executing', 'waiting', 'success', 'canceling', 'canceled', 'failed', 'timedout', 'deferred'].map(x => {
            return {
                key: x,
                value: this.admin.i18n.instant(`TASKS.STATE.${x.toUpperCase()}`),
            };
        });

        const fields: FormBuilderField[] = [
            TextField('name', this.translate('FIELDS.TYPE'), true, 1, 255),
            ComboField('state', this.translate('FIELDS.STATE'), true, values),
            NumberField('retries', this.translate('FIELDS.RETRIES'), true, 0, 100, null),
            NumberField('delay', this.translate('FIELDS.DELAY'), true, 0, 100, this.admin.i18n.instant('SHARED.DATETIME.MINUTES')),
            NumberField('timeout', this.translate('FIELDS.TIMEOUT'), true, 0, 100, this.admin.i18n.instant('SHARED.DATETIME.MINUTES')),
            TextField('user', this.translate('FIELDS.USER'), true, 1, 255),
            MemoField('linked', this.translate('FIELDS.LINKED'), true, 1, 255),
            MemoField('data', this.translate('FIELDS.DATA'), true, 1, 255),
            MemoField('results', this.translate('FIELDS.RESULTS'), true, 1, 255),
            DateTimeField('created', this.translate('FIELDS.CREATED'), true),
            DateTimeField('updated', this.translate('FIELDS.UPDATED'), true),
        ].filter(x => x);
        return EntityUtils.prepareBulk(!entity, [], fields);
    }



}
